import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { getModerationIssues as getModerationIssuesApi } from '../../services/getModerationIssues';
import { actionGenerator } from '../../redux/actionGenerator';
import { EModerationIssuesActionType } from './types';
var getIssuesSucceed = actionGenerator(EModerationIssuesActionType.GetIssuesSucceed);
var getIssuesFailed = actionGenerator(EModerationIssuesActionType.GetIssuesFailed);
export function getModerationIssues(parameters) {
  var _ref;
  return function (_x, _x2, _x3) {
    return (_ref = _ref || _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState, context) {
      var _parameters$ownerOffe, ownerOfferLinkOrId, moderationIssuesResult;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _parameters$ownerOffe = parameters.ownerOfferLinkOrId, ownerOfferLinkOrId = _parameters$ownerOffe === void 0 ? '' : _parameters$ownerOffe;
            _context.next = 3;
            return getModerationIssuesApi(context, {
              query: ownerOfferLinkOrId
            });
          case 3:
            moderationIssuesResult = _context.sent;
            if (!(moderationIssuesResult.status === 'failed')) {
              _context.next = 7;
              break;
            }
            dispatch(getIssuesFailed(moderationIssuesResult.errorMessage));
            throw moderationIssuesResult.errorMessage;
          case 7:
            dispatch(getIssuesSucceed(moderationIssuesResult.data));
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))).apply(this, arguments);
  };
}